import {DetailsList, FontSizes, FontWeights, IconButton, SelectionMode, Stack} from "@fluentui/react";
import AuthContext from "../Services/AuthContext";
import * as React from "react";
import {useContext} from "react";

function UserVentureRestriction(props) {
    const [user] = useContext(AuthContext);

    const columns = [
        {
            key: 'venture',
            name: 'Kontrakt',
            ariaLabel: 'Ograniczenie Kontraktu Użytkownika',
            fieldName: 'venture',
            minWidth: 240,
            isRowHeader: true,
            isResizable: true
        },
        {
            key: 'delete',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'delete',
            minWidth: 50,
            onRender: (item) => (<span>
                <IconButton iconProps={{iconName: 'trash'}} title='Usuń' onClick={() => _delete(item)}/>
            </span>)
        }
    ];

    const _delete = (venture) => {
        fetch(`/api/user/${venture.user_id}/venture/${venture.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.refresh();
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (<Stack.Item>
        <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>{props.title}</h2>
        <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
    </Stack.Item>);
}

UserVentureRestriction.defaultProps = {
    title: 'Ograniczenia Kontraktów Użytkownika'
}

export default UserVentureRestriction;